import { connect } from 'react-redux';
import TwoFactorAuthentication from './TwoFactorAuthentication';

const mapStateToProps = (state: any) => ({
  enforced2fa: state.authSettings.organization.twoFactorAuth.enforced,
  isLoading: state.authSettings.organization.isLoading,
  failed: state.authSettings.organization.failed,
  samlEnabled: state.authSettings.organization.saml?.enabled,
});
export default connect(mapStateToProps, null)(TwoFactorAuthentication);
